import { DemographicValueModel } from './demographic-value-model';

export class DemographicModel {
  readonly id: string;
  readonly name: string;
  readonly isMandatory: boolean;
  readonly values: DemographicValueModel[];
  readonly moniker: string;

  validationMessage: string;

  constructor(id, name, isMandatory, values, moniker) {
    this.id = id;
    this.name = name;
    this.isMandatory = isMandatory;
    this.values = values.sort((v1, v2) => {
      return v1.index - v2.index;
    });
    this.moniker = moniker || this.getMoniker();
  }

  getMoniker(): string {
    if (!this.name) {
      return this.name;
    }

    const parts = this.name.split(' ');
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    parts[0] = parts[0].toLowerCase();
    return parts.join('');
  }
}
